var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-pickup-filters" },
    [
      _c("pickup-filters-actions", {
        attrs: { value: _vm.value },
        on: {
          input: _vm.onInput,
          click: function($event) {
            _vm.isOpenFilters = true
          }
        }
      }),
      _c(
        "transition",
        {
          attrs: { name: "fade" },
          on: {
            "after-enter": function($event) {
              _vm.isOpened = true
            },
            leave: function($event) {
              _vm.isOpened = false
            }
          }
        },
        [
          _vm.isOpenFilters
            ? _c("pickup-filters-list", {
                directives: [
                  {
                    name: "click-outside",
                    rawName: "v-click-outside",
                    value: _vm.onClickOutside,
                    expression: "onClickOutside"
                  }
                ],
                staticClass: "d-pickup-filters__filters",
                attrs: { value: _vm.value },
                on: { input: _vm.onInput }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }